import React from 'react';
import Button from 'shared/components/button/Button';

const QuestionMessage = ({ question, answer, history, clientId }) => {
  return (
    <li className="message-row message-row-left" key={question.id}>
      <div className="message-default message-questionnaire">
        <h5>{question.title}</h5>
        {question.options
          && question.options.length && (
            <div className="question-options">
              {question.options.map(option => {
                if(question.type === "options") {
                  return(
                    <Button
                      customClasses={
                        `${
                          question.options.length > 1 ? 'two-options' :'one-option'
                        } ${answer === option ? "btn-primary" : "btn-secondary inactive"} btn`
                      }
                      color={answer === option ? "primary" : "secondary"}
                      label={option}
                      disabled={true}
                    />
                  );
                } else if (question.type === "redirect") {
                  return(
                    <Button
                      customClasses='one-option btn btn-primary'
                      color="primary"
                      label={option}
                      onClick={ e => {
                        history.push(`/clients/${clientId}/onboardingQuestions/${question.to}`)
                      }}
                    />
                  );
                }
                return null;
              })}
            </div>
          )
        }
      </div>
    </li>
  );
}

export default QuestionMessage;
